export const SETUP_GUIDE_SEED = "Help me set up Productlane."

export const ESCALATION_REVIEW_SEED =
	"The agent handed this conversation to the team. What should we change in our setup so it can solve this next time?"
